// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__3apCV","shadow":"Card_shadow__3e8nj"};